import PaymentError from './payment_error';

const genericErrorMessage = 'We ran into an issue with your payment. Please try again and if you are still having trouble, contact us at <a class="text-danger" href="mailto:help@magoosh.com">help@magoosh.com</a>.'

export { genericErrorMessage, PaymentError };
